import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from '../../pages/login/login.component';

export const LoginRoutes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  }
];

@NgModule({
    imports: [
      RouterModule.forRoot(LoginRoutes, {useHash: true})
    ],
    declarations: [
      LoginComponent
    ],
    exports: [
      LoginComponent
    ]
})
export class LoginProdModule { }
